import { ErrorHandler, NgModule } from '@angular/core';
import {
  DevToolsExtension,
  NgRedux,
  NgReduxModule,
} from '@angular-redux/store';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserLoginService } from './shared/services/user-login.service';
import { CognitoUtil } from './shared/utils/cognito.service';
import { StateManagementService } from './shared/services/state-management.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { loadState, saveState } from './shared/state-management/session-store';
import { INITIAL_STATE, rootReducer } from './shared/state-management/store';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedLayoutModule } from './shared-layout/shared-layout.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { TokenInterceptorModule } from './libs/ui/interceptors/token';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SiteManagementModule } from './site-management/site-management.module';
// import { GraphQLModule } from './graphql.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ErrorInterceptorModule } from './libs/ui/interceptors/error/src/error-interceptor/error-interceptor.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ErrorHandlerService } from './shared/errors/error-handler';
import { SnackbarModule } from './shared/snackbar/snackbar.module';
import { DatePicker } from './shared/utils/date-picker';
import { WithTooltipModule } from './shared-layout/Components/with-tooltip/with-tooltip.module';
import { AppUrlComponent } from './public/appurl/app-url.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LocalizationService } from './shared/services/localization.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
import { DocumentDownloadComponent } from './document-download/document-download.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);


@NgModule({
  declarations: [
    AppComponent,
    AppUrlComponent,
    DocumentDownloadComponent
  ],
  imports: [
    NgReduxModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    SharedLayoutModule,
    WithTooltipModule,
    DashboardModule,
    MatDialogModule,
    TokenInterceptorModule,
    ErrorInterceptorModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    SiteManagementModule,
    // GraphQLModule,
    HttpClientModule,
    NgIdleKeepaliveModule.forRoot(),
    MatSnackBarModule,
    SnackbarModule,
    MatDatepickerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    UserLoginService,
    CognitoUtil,
    StateManagementService,
    LocalizationService,
    TranslateModule,
    { provide: MatBottomSheet },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: DateAdapter, useClass: DatePicker },
    { provide: MAT_DATE_LOCALE, useValue: 'en' }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(ngRedux: NgRedux<any>, devTools: DevToolsExtension,
    private stateManagementService: StateManagementService,
    private dateAdapter: DateAdapter<any>) {
    let persistedState = loadState();
    if (!persistedState) {
      persistedState = INITIAL_STATE;
    }
    // persistedState.appData = INITIAL_STATE.appData;
    ngRedux.configureStore(
      rootReducer,
      persistedState,
      [],
      devTools.isEnabled() ? [devTools.enhancer()] : []
    );
    ngRedux.subscribe(() => {
      const allState = ngRedux.getState();
      saveState(allState);
    });
    const lang = this.stateManagementService.getUserLanguage();
    this.dateAdapter.setLocale(lang === LANG_CONST.FRENCH ? 'fr' : 'en');
  }
}
